import React from "react";
import "../styles/Header.css";
import { Avatar } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTimeRounded";
import SearchIcon from "@material-ui/icons/Search";
import HelpOutlineIcon from "@material-ui/icons/HelpOutlineRounded";
import { useStateValue } from "../StateProvider";

function Header() {

    const [{ user }] = useStateValue();
    return (
        <div className="header">
            <div className="header-left">
                <img src="https://thumbs.bfldr.com/at/pljt3c-dcwb20-c19uuy/v/2995547?expiry=1638022923&fit=bounds&height=800&sig=MmFjOWM2NWQ0MTA0NGQ1MWMwMWM3NGE4MzhkYmY0OWJmYWNmNDY3Yg%3D%3D&width=1100"
                 alt="slack-logo" />
                {/* Time icon */}
                <AccessTimeIcon />
            </div>
            <div className="header-search">
                {/* Search Icon and Input Box*/}
                <SearchIcon />
                <input placeholder="Search Cybertron"></input>

            </div>
            <div className="header-right">
                {/* Help Icon */}
                <HelpOutlineIcon />
                {/* Avatar of Logged in user */}
                <Avatar className="header-avatar" alt={user?.displayName} src={user?.photoURL}
                
                />
            </div>
        </div>
    );
}

export default Header;
